/**
 * Desenul de planșă din josul barei laterale (cerut de proprietar, 2026-10-10,
 * după o referință): clădiri în construcție și o macara, ca linii albastre fine
 * pe fundalul închis. E decor, deci ascuns cititoarelor de ecran și fără clic.
 */
export function RailArt() {
  const win: string[] = [];
  // ferestrele blocului înalt: un caroiaj de 4 × 9
  for (let r = 0; r < 9; r++) {
    for (let c = 0; c < 4; c++) win.push(`M${36 + c * 14} ${96 + r * 14}h8v8h-8z`);
  }
  // ferestrele blocului din dreapta: 3 × 5
  for (let r = 0; r < 5; r++) {
    for (let c = 0; c < 3; c++) win.push(`M${118 + c * 13} ${152 + r * 14}h7v8h-7z`);
  }
  return (
    <svg className="rail-art" viewBox="0 0 240 240" aria-hidden="true" focusable="false">
      <g fill="none" stroke="currentColor" strokeWidth="1" strokeLinejoin="round">
        {/* blocul înalt, cu schela pe o latură */}
        <path d="M28 236V86h68v150" />
        <path d="M28 86l34-14 34 14" opacity=".7" />
        <path d={win.join('')} opacity=".55" />
        <path d="M100 236V112M108 236V112M100 124h8M100 148h8M100 172h8M100 196h8M100 220h8" opacity=".6" />
        {/* blocul din dreapta, pe jumătate ridicat */}
        <path d="M110 236V144h46v92" />
        <path d="M110 144l6-10h34l6 10" strokeDasharray="3 3" opacity=".7" />
        {/* macaraua: turnul cu zăbrele, brațul, cablul */}
        <path d="M186 236V40M196 236V40" />
        <path d="M186 60l10 12M196 60l-10 12M186 84l10 12M196 84l-10 12M186 108l10 12M196 108l-10 12M186 132l10 12M196 132l-10 12M186 156l10 12M196 156l-10 12M186 180l10 12M196 180l-10 12M186 204l10 12M196 204l-10 12" opacity=".6" />
        <path d="M120 40h112M120 40l66-16 10 16M232 40v6h-14v-6" />
        <path d="M140 40v46" strokeDasharray="2 2" opacity=".8" />
        <path d="M134 86h12v8h-12z" />
        {/* cota de jos, ca pe planșă */}
        <path d="M28 230h128M28 226v8M156 226v8" opacity=".5" />
        <path d="M4 236h232" />
      </g>
    </svg>
  );
}
